/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, {PropTypes} from 'react';
import { Link } from 'react-router';
import Utils from 'frilans-finans/utils/utils';
import Ellipsis from '../../../../components/svg/ellipsis';
import ShowMore from '../../../../components/show-more/show-more-invoice';

export const systemCurrencyId = 1;

export class InvoiceRow extends React.Component {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    toggleShowMoreList: PropTypes.func.isRequired,
    resetShowMoreList: PropTypes.func.isRequired,
    showMoreList: PropTypes.object.isRequired
  };

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.showMoreList = this.showMoreList.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef (node) {
    this.wrapperRef = node;
  }

  handleClickOutside (event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.props.showMoreList.invoiceId === this.props.invoice.id) {
        this.props.resetShowMoreList();
      }
    }
  }

  showMoreList () {
    this.props.toggleShowMoreList(this.props.invoice.id);
  };

  renderShowMore (showMoreList, route) {
    if (showMoreList) {
      return <ShowMore
        invoice={this.props.invoice}
        invoiceRoute={route}
        user={this.context.user}
      />;
    }
  }

  render () {
    let route = '/economy/invoices/' + this.props.invoice.id;
    let showMoreList = +this.props.showMoreList.invoiceId === +this.props.invoice.id
      ? this.props.showMoreList.show
      : false;

    return (
      <tr className='invoices-table-body'>
        <td className='invoice-table-body-column'>
          {Utils.formatDate(this.props.invoice.createdAt)}
        </td>
        <td className='invoice-table-body-column'>
          <span>{this.props.invoice.customer.name}</span>
        </td>
        <td className='invoice-table-body-column hide-mobile'>
          <Link to={route}>{this.props.invoice.id}</Link>
        </td>
        <td className='invoice-table-body-column'>
          {Utils.amountWithCurrency(Math.round(this.props.invoice.amount), systemCurrencyId)}
        </td>
        <td className='invoice-table-body-column hide-mobile'>
          {this.props.invoice.approvalStatusText}
        </td>
        <td
          ref={this.setWrapperRef}
          className='invoice-table-body-column more'
          onClick={this.showMoreList}
        >
          {this.renderShowMore(showMoreList, route)}
          <Ellipsis
            colorSchema='primary'
            fill={showMoreList}
          />
        </td>
      </tr>
    );
  }
}

export default InvoiceRow;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/invoices/table-content/invoice-row.js
 **/